module.exports = __webpack_public_path__ + "img/minuteHand.c01c064b.png";